import type { GalleryImageT } from '../../../../../type/galleryImageT';

import {
  ProductGalleryThumb,
  ProductGalleryThumbImage,
  ProductGalleryVariant,
} from '@vs-shop/commerce-ui/productGallery';

import { resolveImageUrl } from '@vs-shop/engine/image/resolveImageUrl';

import { ImageFilter } from '@vs-shop/engine/image/ImageFilter';

type Props = {
  image: GalleryImageT;
  selected: boolean;
  onClick: () => void;
  alt: string;
};

/**
 * One photograph in the thumb rail.
 *
 * The Liip thumbnail crop is this tenant's; which thumb is the current one
 * reaches the shared part as `aria-current` and as nothing else.
 */
export function GalleryThumbImage({ image, selected, onClick, alt }: Props) {
  const path = image.pathAbstract
    ? resolveImageUrl(image.pathAbstract, ImageFilter.product_gallery_preview_thumbnail)
    : '';

  return (
    <ProductGalleryThumb
      variant={ProductGalleryVariant.INLINE}
      aria-current={selected ? true : undefined}
      tabIndex={0}
      onClick={onClick}
      aria-label={path}
    >
      <ProductGalleryThumbImage
        variant={ProductGalleryVariant.INLINE}
        src={path}
        alt={alt}
        width={168}
        height={127}
      />
    </ProductGalleryThumb>
  );
}
